import React, { useEffect, useState } from 'react';
import { useLoadingScreen } from '../../../hooks/useLoadingScreen';
import style from './TurbineManagement.module.scss';
import { useTranslation } from 'react-i18next';
import {
  ButtonPrimary,
  Checkbox,
  DataTable,
  IconPencil,
  IconTrash,
  Input,
  SelectInputSearch,
  IconTurbine,
} from '@skf/bt-wind-rail-commonlibrary';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/store';
import { ITaxonomyState } from '../../../store/taxonomy/store';
import { fetchTaxonomy, fetchAssets } from '../../../store/taxonomy/actions';
import {
  WindTaxonomy,
  TaxonomyCustomerAdmin,
  TaxonomySystemInfoAdmin,
  TaxonomySystemInfoAdminCompleted,
  TaxonomyAssetInfoAdmin,
  TaxonomyBearingInfoAdmin,
  TaxonomyBearingInfoAdminCompleted,
} from '../../../store/taxonomy/types';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';
import { TurbineManagmentExcell } from './excell/TurbineManagmentExcell';
import { TurbineManagementDelete } from './delete/TurbineManagementDelete';
import { TurbineManagementFormulary } from './formulary/TurbineManagementFormulary';
import { TurbineManagementFormularyTurbine } from './formulary/TurbineManagementFormularyTurbine';
// import { useToast } from '../../../hooks/useToast';
import { TurbineManagementFormularyAssets } from './formulary/TurbineManagementFormulayAssets';
import { TurbineManagementFormularyBearings } from './formulary/TurbineManagementFormularyBearings';
// import { StatusTypes } from '@skf/bt-wind-rail-commonlibrary/dist/types/Status';
import { fetchExcelData, fetchExcelEditedData } from '../../../api/excel';
import { useToast } from '../../../hooks/useToast';
const taxonomyOptions = [
  { label: 'WindFarms', labelToShow: 'WindFarms', value: 'WindFarms' },
  { label: 'Turbines', labelToShow: 'Turbines', value: 'Turbines' },
  { label: 'Assets', labelToShow: 'Assets', value: 'Assets' },
  { label: 'Bearings', labelToShow: 'Bearings', value: 'Bearings' },
];

export const TurbineManagement = () => {
  const { addToast } = useToast();
  const { setLoading } = useLoadingScreen();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [_taxonomyToDelete, _setTaxonomyToDelete] = useState<
    string | undefined
  >(undefined);
  const [_taxonomyToFormulary, _setTaxonomyToFormulary] = useState<
    TaxonomyCustomerAdmin | undefined
  >(undefined);
  const [_taxonomy, _setTaxonomy] = useState<WindTaxonomy[]>([]);
  const [_taxonomyFilter, _setTaxonomyFilter] = useState<string>('');
  const [_openModal, _setOpenModal] = useState<boolean>(false);
  const [_openModalTurbine, _setOpenModalTurbine] = useState<boolean>(false);
  const [_openModalAssets, _setOpenModalAssets] = useState<boolean>(false);
  const [_openModalBearings, _setOpenModalBearings] = useState<boolean>(false);
  const { taxonomy } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomy
  );
  const { taxonomyAssets } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomy
  );
  const [isActionChecked, setActionChecked] = useState(false);
  const [taxonomySelected, seTaxonomySelected] = useState('WindFarms');
  const [isEditedOnly, setEditedOnly] = useState(false);
  const [_windFarmFiltered, _setWindFarmFiltered] = useState<
    TaxonomyCustomerAdmin[]
  >([]);
  const [_turbineFiltered, _setTurbineFiltered] = useState<
    TaxonomySystemInfoAdminCompleted[]
  >([]);
  const [_windFarm, _setWindFarm] = useState<TaxonomyCustomerAdmin[]>([]);
  const [_turbine, _setTurbine] = useState<TaxonomySystemInfoAdminCompleted[]>(
    []
  );
  const [_assets, _setAssets] = useState<TaxonomyAssetInfoAdmin[]>([]);
  const [_bearings, _setBearings] = useState<TaxonomyBearingInfoAdmin[]>([]);
  const [_assetsFiltered, _setAssetsFiltered] = useState<
    TaxonomyAssetInfoAdmin[]
  >([]);
  const [_bearingsFiltered, _setBearingsFiltered] = useState<
    TaxonomyBearingInfoAdmin[]
  >([]);
  const [_turbineOptions, _setTurbineOptions] = useState<IOption[]>([]);
  const [_assetToFormulary, _setAssetToFormulary] = useState<
    TaxonomyAssetInfoAdmin | undefined
  >(undefined);
  const [dataToDownload, setDataToDownload] = useState([]);
  const [turbineSelected, setTurbineSelected] = useState<string | number>('');

  useEffect(() => {
    if (taxonomy) {
      _setTaxonomy(taxonomy);
      _setWindFarm(
        taxonomy
          .map((e: WindTaxonomy) => e.taxonomyCustomer)
          .filter(
            (e: TaxonomyCustomerAdmin) =>
              e.customerStatus === 'Active' ||
              e.customerStatus === 'Draft' ||
              e.customerStatus === 'Pending'
          )
      );
      _setWindFarmFiltered(
        taxonomy
          .map((e: WindTaxonomy) => e.taxonomyCustomer)
          .filter(
            (e: TaxonomyCustomerAdmin) =>
              e.customerStatus === 'Active' ||
              e.customerStatus === 'Draft' ||
              e.customerStatus === 'Pending'
          )
      );
      const turbines: TaxonomySystemInfoAdminCompleted[] = [];
      taxonomy.map((e: WindTaxonomy) =>
        e.taxonomyCustomer.taxonomySystemInfos.forEach(
          (e2: TaxonomySystemInfoAdmin) => {
            if (
              e2.systemInfoStatus === 'Confirmed' ||
              e2.systemInfoStatus === 'Draft' ||
              e2.systemInfoStatus === 'Pending'
            ) {
              const turbine: TaxonomySystemInfoAdminCompleted = e2;
              turbine.companyName = e.taxonomyCustomer.companyName;
              turbine.siteCountryCode = e.taxonomyCustomer.siteCountryCode;
              turbine.siteCountryDescription =
                e.taxonomyCustomer.siteCountryDescription;
              turbine.plantUnitDescription =
                e.taxonomyCustomer.plantUnitDescription;
              turbines.push(turbine);
            }
          }
        )
      );

      getAllTurbines(turbines);
      _setTurbine(turbines);
      _setTurbineFiltered(turbines);
      return setLoading(false);
    }

    dispatch(fetchTaxonomy());
  }, [taxonomy]);

  useEffect(() => {
    if (turbineSelected) {
      getAssets(turbineSelected);
    }
  }, [taxonomy]);

  // useEffect(() => {
  //   setInterval(() => {
  //     fetchOperationStatus().then((res) => handleOperationStatus(res));
  //   }, 10000);
  // }, []);

  // const handleOperationStatus = (res) => {
  //   res.map((currentStatusOperation) => {
  //     const { id = '', status = 1 } = currentStatusOperation;
  //     let type = '';
  //     let operation = '';

  //     const showToast = (toastStatus: StatusTypes, messageToast: string) => {
  //       addToast({
  //         timeout: 20000,
  //         status: toastStatus,
  //         message: messageToast,
  //       });
  //       dispatch(fetchTaxonomy());
  //     };

  //     if (id.includes('Update')) operation = t('Modified');
  //     else if (id.includes('Insert')) operation = t('Added');
  //     else if (id.includes('Delete')) operation = t('Deleted');
  //     if (id.includes('TaxonomySystemInfo')) type = t('Turbine');
  //     else if (id.includes('TaxonomyCustomer')) type = t('Wind_Farm');
  //     else if (id.includes('TaxonomyPart')) type = t('Bearing');
  //     else if (id.includes('TaxonomyAsset')) type = t('asset');

  //     type = type.charAt(0).toUpperCase().concat(type.slice(1));

  //     //2 seems to be ok and -1 seems to be failed.
  //     //the process seems to update frequently and the status returns 1.
  //     let messageToast: string = '';
  //     let toastStatus: StatusTypes = 'danger';
  //     switch (status) {
  //       // Operation is valid
  //       case 2:
  //         messageToast = `${type} ${t(
  //           'successOperation'
  //         )} ${operation.toLowerCase()}`;
  //         toastStatus = 'ok';
  //         showToast(toastStatus, messageToast);
  //         break;
  //       // Operation failed
  //       case -1:
  //         messageToast = t('failedOperation');
  //         showToast(toastStatus, messageToast);
  //         break;
  //       default:
  //         break;
  //     }
  //   });
  // };

  useEffect(() => {
    const checkboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll(
      `input[name="table-row"]`
    );

    checkboxes.forEach(
      (checkbox: HTMLInputElement) => (checkbox.checked = isActionChecked)
    );
  }, [isActionChecked, taxonomySelected]);

  useEffect(() => {
    if (taxonomyAssets) {
      _setAssets(taxonomyAssets);
      _setAssetsFiltered(taxonomyAssets);
      const bearings: TaxonomyBearingInfoAdminCompleted[] = [];
      taxonomyAssets.map((as: TaxonomyAssetInfoAdmin) => {
        as.taxonomiesPart.map((be: TaxonomyBearingInfoAdmin) => {
          const beAux: TaxonomyBearingInfoAdminCompleted = be;
          beAux.assetId = as.assetId;
          bearings.push(beAux);
        });
      });
      _setBearingsFiltered(bearings);
      _setBearings(bearings);
    }
  }, [taxonomyAssets]);

  const columnsWindFarm: any[] = [
    {
      Header: (
        <Checkbox
          square
          isChecked={isActionChecked}
          onClick={() => {
            setActionChecked(!isActionChecked);
          }}
        />
      ),
      accessor: 'Action1',
      className: style.columnOne,
      disableSortBy: true,
      Cell: (data) => {
        const { row: { original = {} } = {} } = data;
        const { plantUnitKey = '' } = original;

        return (
          <div className={style.iconsColumns}>
            <input
              className={style.checkbox2}
              type="checkbox"
              id={plantUnitKey}
              name="table-row"
              value={plantUnitKey}
            />
          </div>
        );
      },
    },
    {
      Header: t('Company'),
      accessor: 'companyName',
      className: style.columnTwo,
    },
    {
      Header: t('Country'),
      accessor: 'siteCountryDescription',
      className: style.columnThree,
    },
    {
      Header: t('Wind_farm_id'),
      accessor: 'plantUnitId',
      className: style.columnFour,
    },
    {
      Header: t('Wind_farm_description'),
      accessor: 'plantUnitDescription',
      className: style.columnFive,
    },

    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnSix,
      Cell: ({
        row: {
          original: { plantUnitDescription, plantUnitId },
          original,
        },
      }: any) => {
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              onClick={() => {
                _setTaxonomyToFormulary(original);
                _setOpenModal(true);
              }}
              className={style.cursorPointer}
            />
            <IconTrash
              onClick={() => _setTaxonomyToDelete(plantUnitId)}
              className={style.cursorPointer}
            />
            <IconTurbine
              onClick={() => filterByWinfarm(plantUnitDescription)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  const columnsTurbine: any[] = [
    {
      Header: (
        <Checkbox
          square
          isChecked={isActionChecked}
          onClick={() => setActionChecked(!isActionChecked)}
        />
      ),
      accessor: 'Action1',
      className: style.columnOne,
      disableSortBy: true,
      Cell: (data) => {
        const { row: { original = {} } = {} } = data;
        const { plantUnitKey = '' } = original;

        return (
          <div className={style.iconsColumns}>
            <input
              className={style.checkbox2}
              type="checkbox"
              id={plantUnitKey}
              name="table-row"
              value={plantUnitKey}
            />
          </div>
        );
      },
    },
    {
      Header: t('Company'),
      accessor: 'companyName',
      className: style.columnTwo,
    },
    {
      Header: t('Country'),
      accessor: 'siteCountryCode',
      className: style.columnThree,
    },
    {
      Header: t('Wind_Farm'),
      accessor: 'plantUnitDescription',
      className: style.columnFour,
    },
    {
      Header: t('Turbine'),
      accessor: 'sectionSystemId',
      className: style.columnFive,
    },
    {
      Header: t('Model'),
      accessor: 'systemModel',
      className: style.columnFive,
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnSix,
      Cell: ({
        row: {
          original: { sectionSystemId },
          original,
        },
      }: any) => {
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              onClick={() => {
                _setTaxonomyToFormulary(original);
                _setOpenModalTurbine(true);
              }}
              className={style.cursorPointer}
            />
            <IconTrash
              onClick={() => _setTaxonomyToDelete(sectionSystemId)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  const columnsAssets: any[] = [
    {
      Header: (
        <Checkbox
          square
          isChecked={isActionChecked}
          onClick={() => setActionChecked(!isActionChecked)}
        />
      ),
      accessor: 'Action1',
      className: style.columnOne,
      disableSortBy: true,
      Cell: (data) => {
        const { row: { original = {} } = {} } = data;
        const { plantUnitKey = '' } = original;

        return (
          <div className={style.iconsColumns}>
            <input
              className={style.checkbox2}
              type="checkbox"
              id={plantUnitKey}
              name="table-row"
              value={plantUnitKey}
            />
          </div>
        );
      },
    },
    {
      Header: t('Asset_id'),
      accessor: 'assetId',
      className: style.columnTwo,
    },
    {
      Header: t('Asset_desc'),
      accessor: 'assetClassDescription',
      className: style.columnFour,
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnSix,
      Cell: ({
        row: {
          original: { assetId },
          original,
        },
      }: any) => {
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              onClick={() => {
                _setAssetToFormulary(original);
                _setTaxonomyToFormulary(original);
                _setOpenModalAssets(true);
              }}
              className={style.cursorPointer}
            />
            <IconTrash
              onClick={() => _setTaxonomyToDelete(assetId)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  const columnsBearings: any[] = [
    {
      Header: (
        <Checkbox
          square
          isChecked={isActionChecked}
          onClick={() => setActionChecked(!isActionChecked)}
        />
      ),
      accessor: 'Action1',
      className: style.columnOne,
      disableSortBy: true,
      Cell: (data) => {
        const { row: { original = {} } = {} } = data;
        const { assetKey = '' } = original;
        const value = _turbineFiltered.find(
          (currentTurbine) =>
            currentTurbine.sectionSystemKey ===
              _assetsFiltered.find(
                (currentAsset) => currentAsset.assetKey === assetKey
              )?.sectionSystemKey || ''
        )?.plantUnitKey;

        return (
          <div className={style.iconsColumns}>
            <input
              className={style.checkbox2}
              type="checkbox"
              id={value}
              name="table-row"
              value={value}
            />
          </div>
        );
      },
    },
    {
      Header: t('Asset_id'),
      accessor: 'assetId',
      className: style.columnTwo,
    },
    {
      Header: t('position'),
      accessor: 'position',
      className: style.columnTwo,
    },

    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnSix,
      Cell: ({
        row: {
          original: { position },
          original,
        },
      }: any) => {
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              onClick={() => {
                _setTaxonomyToFormulary(original);
                _setOpenModalBearings(true);
              }}
              className={style.cursorPointer}
            />
            <IconTrash
              onClick={() => _setTaxonomyToDelete(position)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  async function getDataExcel() {
    const checkboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll(
      `input[name="table-row"]:checked`
    );

    let windfarmsChecked: string[] = [];

    checkboxes.forEach((checkbox) => {
      windfarmsChecked.push(checkbox.id);
    });

    const downloadExcelStarted = () => {
      addToast({
        status: 'warning',
        message: t('windfarmExcelProcess'),
      });
    };

    const downloadExcelOk = () => {
      addToast({
        status: 'ok',
        message: t('windfarmExcelProcessOk'),
      });
    };

    const downloadExcelFailed = () => {
      addToast({
        status: 'danger',
        message: t('windfarmExcelProcessError'),
      });
    };

    setLoading(true);
    let fetchedData = isEditedOnly
      ? await fetchExcelEditedData(
          downloadExcelStarted,
          downloadExcelOk,
          downloadExcelFailed
        )
      : await fetchExcelData(
          [...new Set(windfarmsChecked)],
          downloadExcelStarted,
          downloadExcelOk,
          downloadExcelFailed
        );
    setLoading(false);

    const formattedData = fetchedData.map((data) => {
      const {
        sectorCode,
        sectorDescription,
        segmentCode,
        segmentDescription,
        industryCode,
        industryDescription,
        companyId,
        companyName,
        siteId,
        siteDescription,
        siteAreaDescription,
        siteCountryCode,
        siteCountryDescription,
        plantUnitId,
        plantUnitDescription,
        plantUnitCategory,
        plantUnitCapacity,
        plantUnitContributionMargin,
        sectionSystemId,
        sectionSystemDescription,
        systemBrand,
        systemModel,
        sectionSystemCapacity,
        sectionSystemContributionMargin,
        latitude,
        longitude,
        commisioningDate,
        sectionSystemId2,
        assetCategoryCode,
        assetCategoryDescription,
        assetClassCode,
        assetClassDescription,
        assetTypeCode,
        assetTypeDescription,
        assetSequenceCode,
        assetSequenceDescription,
        assetClassTypeCode,
        assetClassTypeDescription,
        assetId,
        manufacturerModel,
        manufacturerName,
        manufacturerSerialNumber,
        costReplacement,
        purchaseCondition,
        equipAttributes,
        assetInstalledDate,
        assetId2,
        position,
        partId,
        skfProductGroup,
        partName,
        partManufacturer,
        skfPartCode,
        competitorProductIdentification,
        oemPartCode,
        oemPartDescription,
        customerPartCode,
        customerPartDescription,
        partInstalledDate,
      } = data;

      return [
        { value: sectorCode || '' },
        { value: sectorDescription || '' },
        { value: segmentCode || '' },
        { value: segmentDescription || '' },
        {
          value: industryCode || '',
          style: { alignment: { horizontal: 'left' } },
        },
        { value: industryDescription || '' },
        { value: companyId || '' },
        { value: companyName || '' },
        { value: siteId || '' },
        { value: siteDescription || '' },
        { value: siteAreaDescription || '' },
        { value: siteCountryCode || '' },
        { value: siteCountryDescription || '' },
        { value: plantUnitId || '' },
        { value: plantUnitDescription || '' },
        { value: plantUnitCategory || '' },
        { value: plantUnitCapacity || '' },
        { value: plantUnitContributionMargin || '' },
        { value: sectionSystemId || '' },
        { value: sectionSystemDescription || '' },
        { value: systemBrand || '' },
        { value: systemModel || '' },
        { value: sectionSystemCapacity || '' },
        { value: sectionSystemContributionMargin || '' },
        { value: latitude || '', style: { alignment: { horizontal: 'left' } } },
        {
          value: longitude || '',
          style: { alignment: { horizontal: 'left' } },
        },
        { value: commisioningDate || '' },
        { value: sectionSystemId2 || '' },
        { value: assetCategoryCode || '' },
        { value: assetCategoryDescription || '' },
        { value: assetClassCode || '' },
        { value: assetClassDescription || '' },
        { value: assetTypeCode || '' },
        { value: assetTypeDescription || '' },
        { value: assetSequenceCode || '' },
        { value: assetSequenceDescription || '' },
        { value: assetClassTypeCode || '' },
        { value: assetClassTypeDescription || '' },
        { value: assetId || '' },
        { value: manufacturerModel || '' },
        { value: manufacturerName || '' },
        { value: manufacturerSerialNumber || '' },
        { value: costReplacement || '' },
        { value: purchaseCondition || '' },
        { value: equipAttributes || '' },
        { value: assetInstalledDate || '' },
        { value: assetId2 || '' },
        { value: position || '' },
        { value: partId || '' },
        { value: skfProductGroup || '' },
        { value: partName || '' },
        { value: partManufacturer || '' },
        { value: skfPartCode || '' },
        { value: competitorProductIdentification || '' },
        { value: oemPartCode || '' },
        { value: oemPartDescription || '' },
        { value: customerPartCode || '' },
        { value: customerPartDescription || '' },
        { value: partInstalledDate || '' },
      ];
    });

    setDataToDownload(formattedData);
  }

  const columnsExcell: any[] = [
    { title: 'Sector code (L1)', width: { wpx: 140 } },
    { title: 'Sector description (L1)', width: { wpx: 160 } },
    { title: 'Segment code (L0)', width: { wpx: 140 } },
    { title: 'Segment description (L0)', width: { wpx: 160 } },
    { title: 'Industry code (L3)', width: { wpx: 150 } },
    { title: 'Industry description (L3)', width: { wpx: 280 } },
    { title: 'Owner ID (ID for company)', width: { wpx: 200 } },
    { title: 'Owner_Name', width: { wpx: 130 } },
    { title: 'Site ID', width: { wpx: 100 } },
    { title: 'Site Description', width: { wpx: 150 } },
    {
      title: 'Site Area Description (Region e.g. NAM/LAM/EU/APAC/ASIA)',
      width: { wpx: 400 },
    },
    { title: 'Site country Code', width: { wpx: 160 } },
    { title: 'Site country description', width: { wpx: 240 } },
    { title: 'Plant_ID', width: { wpx: 200 } },
    { title: 'Plant Description (Wind Farm Name)', width: { wpx: 250 } },
    { title: 'Plant Category', width: { wpx: 100 } },
    { title: 'Plant Capacity (Wind farm capacity MW)', width: { wpx: 250 } },
    { title: 'Plant contribution margin (Euro per MW/h)', width: { wpx: 270 } },
    { title: 'System_ID', width: { wpx: 150 } },
    { title: 'System Description (Turbine Name)', width: { wpx: 230 } },
    { title: 'System Brand', width: { wpx: 100 } },
    { title: 'System Model', width: { wpx: 100 } },
    { title: 'System Capacity (Turbine MW)', width: { wpx: 200 } },
    {
      title: 'System contribution margin (Euro per MW/h)',
      width: { wpx: 300 },
    },
    { title: 'Latitude', width: { wpx: 100 } },
    { title: 'Longitude', width: { wpx: 100 } },
    { title: 'Commisioning Date', width: { wpx: 200 } },
    { title: 'System_ID', width: { wpx: 175 } },
    { title: 'Asset category code (L1)', width: { wpx: 175 } },
    { title: 'Asset category description (L1)', width: { wpx: 200 } },
    { title: 'Asset class code (L2)', width: { wpx: 180 } },
    { title: 'Asset class description (L2)', width: { wpx: 200 } },
    { title: 'Asset type code (L3)', width: { wpx: 165 } },
    { title: 'Asset type description (L3)', width: { wpx: 200 } },
    { title: 'Asset sequence code (L4)', width: { wpx: 160 } },
    { title: 'Asset sequence description (L4)', width: { wpx: 220 } },
    { title: 'Asset class type code (L5)', width: { wpx: 200 } },
    { title: 'Asset class type description (L5)', width: { wpx: 220 } },
    { title: 'Asset_ID', width: { wpx: 250 } },
    { title: 'Manufacturer name (L6)', width: { wpx: 200 } },
    { title: 'Manufacturer model (L6)', width: { wpx: 200 } },
    { title: 'Manufacturer serial number (L6)', width: { wpx: 220 } },
    { title: 'Cost of replacement Euro (L6)', width: { wpx: 210 } },
    { title: 'Purchase condition (L6)', width: { wpx: 210 } },
    {
      title: 'Equip attributes - electronic file attachment (L6)',
      width: { wpx: 340 },
    },
    { title: 'Installed date', width: { wpx: 180 } },
    { title: 'Asset_ID', width: { wpx: 250 } },
    { title: 'Position', width: { wpx: 120 } },
    { title: 'Bearing_ID', width: { wpx: 150 } },
    { title: 'SKF product group', width: { wpx: 180 } },
    { title: 'Part name', width: { wpx: 120 } },
    { title: 'Part manufacturer', width: { wpx: 140 } },
    { title: 'SKF product identification (designation)', width: { wpx: 300 } },
    {
      title: 'Competitor product identification (designation)',
      width: { wpx: 340 },
    },
    { title: 'OEM part identification', width: { wpx: 220 } },
    { title: 'OEM part description', width: { wpx: 210 } },
    { title: 'Customer part identification', width: { wpx: 220 } },
    { title: 'Customer part description', width: { wpx: 240 } },
    { title: 'Installed date', width: { wpx: 180 } },
  ];

  const filterByWinfarm = (e: string) => {
    seTaxonomySelected('Turbines');
    onISChange(e);
  };

  const getColums = () => {
    switch (taxonomySelected) {
      case 'WindFarms':
        return columnsWindFarm;
      case 'Turbines':
        return columnsTurbine;
      case 'Assets':
        return columnsAssets;
      case 'Bearings':
        return columnsBearings;
      default:
        return columnsWindFarm;
    }
  };

  const getDataColums = () => {
    switch (taxonomySelected) {
      case 'WindFarms':
        return _windFarmFiltered;
      case 'Turbines':
        return _turbineFiltered;
      case 'Assets':
        return _assetsFiltered;
      case 'Bearings':
        return _bearingsFiltered;
      default:
        return columnsWindFarm;
    }
  };

  function getAllTurbines(turbines: TaxonomySystemInfoAdminCompleted[]) {
    if (!turbines) return;
    const filtertTurbines: IOption[] = [];
    turbines.map((e: TaxonomySystemInfoAdminCompleted) => {
      if (
        e.systemBrand &&
        !filtertTurbines.find((e2: IOption) => e2.value === e.sectionSystemId)
      ) {
        filtertTurbines.push({
          label: e.sectionSystemId,
          value: e.sectionSystemId,
          labelToShow: e.sectionSystemId,
        });
      }
      _setTurbineOptions(filtertTurbines);
    });
  }

  const onISChange = (v: string) => {
    _setTaxonomyFilter(v);
    setEditedOnly(false);
    _setTurbineFiltered(
      _turbine.filter(
        (e) => JSON.stringify(e).toLowerCase().indexOf(v.toLowerCase()) > -1
      )
    );
    _setWindFarmFiltered(
      _windFarm.filter(
        (e) => JSON.stringify(e).toLowerCase().indexOf(v.toLowerCase()) > -1
      )
    );
    _setAssetsFiltered(
      _assets.filter(
        (e) => JSON.stringify(e).toLowerCase().indexOf(v.toLowerCase()) > -1
      )
    );
    _setBearingsFiltered(
      _bearings.filter(
        (e) => JSON.stringify(e).toLowerCase().indexOf(v.toLowerCase()) > -1
      )
    );
  };

  function onSelectedItmChanged(e: IOption | void) {
    if (e) seTaxonomySelected(e.value.toString());
  }

  function getTaxonomy(id: string) {
    let taxonomyToDelete:
      | WindTaxonomy
      | TaxonomySystemInfoAdminCompleted
      | TaxonomyAssetInfoAdmin
      | TaxonomyBearingInfoAdmin
      | undefined;
    if (taxonomySelected === 'WindFarms')
      taxonomyToDelete = _taxonomy.find(
        (e: WindTaxonomy) => e.taxonomyCustomer.plantUnitId === id
      );
    if (taxonomySelected === 'Turbines')
      taxonomyToDelete = _turbine.find(
        (e: TaxonomySystemInfoAdminCompleted) => e.sectionSystemId === id
      );
    if (taxonomySelected === 'Assets')
      taxonomyToDelete = _assets.find(
        (e: TaxonomyAssetInfoAdmin) => e.assetId === id
      );
    if (taxonomySelected === 'Bearings')
      taxonomyToDelete = _bearings.find(
        (e: TaxonomyBearingInfoAdmin) => e.position === id
      );
    return taxonomyToDelete;
  }

  function getAssets(option: string | number) {
    const getTurbineAssets:
      | TaxonomySystemInfoAdminCompleted
      | undefined = _turbine.find((e: TaxonomySystemInfoAdminCompleted) => {
      if (option && e.sectionSystemId === option) return e;
      else return false;
    });
    dispatch(
      fetchAssets(
        getTurbineAssets?.plantUnitKey,
        getTurbineAssets?.sectionSystemKey
      )
    );
  }

  const onTurbneManagerDeleteClose = () => {
    _setTaxonomyToDelete(undefined);
  };

  const onTurbneManagerFormularyClose = () => {
    _setTaxonomyToFormulary(undefined);
    _setOpenModal(false);
    _setOpenModalTurbine(false);
    _setOpenModalAssets(false);
    _setOpenModalBearings(false);
  };

  return (
    <div>
      <div
        className={`${style.actions}`}
      >
        <div className={style.download}>
          <TurbineManagmentExcell
            data={dataToDownload}
            columns={columnsExcell}
            onClick={() => getDataExcel()}
          />
          <Checkbox
            square
            isChecked={isEditedOnly}
            className={style.checkbox1}
            onClick={() => setEditedOnly(!isEditedOnly)}
          >
            <div className={style.edited}>{t('Edited_only')}</div>
          </Checkbox>
        </div>
        <div className={style.buttons}>
          {taxonomySelected === 'Turbines' && (
            <ButtonPrimary onClick={() => _setOpenModalTurbine(true)}>
              {t('Add_Turbine')}
            </ButtonPrimary>
          )}
          {taxonomySelected === 'WindFarms' && (
            <ButtonPrimary onClick={() => _setOpenModal(true)}>
              {t('Add_Wind_Farm')}
            </ButtonPrimary>
          )}
          {taxonomySelected === 'Assets' && (
            <ButtonPrimary
              onClick={() => {
                _setAssetToFormulary(undefined);
                _setOpenModalAssets(true);
              }}
            >
              {t('Add_Wind_Assets')}
            </ButtonPrimary>
          )}
          {taxonomySelected === 'Bearings' && (
            <ButtonPrimary onClick={() => _setOpenModalBearings(true)}>
              {t('Add_Wind_Bearings')}
            </ButtonPrimary>
          )}
        </div>
      </div>
      <div
        className={
          taxonomySelected === 'Assets' || taxonomySelected === 'Bearings'
            ? style.filtersAssets
            : style.filters
        }
      >
        <div className={style.input}>
          <Input
            className={style.inputSearch}
            placeholder={`${t('Search')}...`}
            onChange={onISChange}
            value={_taxonomyFilter}
          />
        </div>
        {(taxonomySelected === 'Assets' || taxonomySelected === 'Bearings') && (
          <div className={style.selector}>
            <SelectInputSearch
              placeHolder={t('Turbine')}
              translate={t}
              options={_turbineOptions}
              value={turbineSelected}
              onSelectedItemChanged={(e: IOption | undefined) => {
                setTurbineSelected(e?.value || '');
                getAssets(e?.value || '');
              }}
            />
          </div>
        )}
        <div className={style.selector}>
          <SelectInputSearch
            placeHolder={t('Taxonomy')}
            translate={t}
            options={taxonomyOptions}
            onSelectedItemChanged={(e: IOption | void) =>
              onSelectedItmChanged(e)
            }
            value={taxonomySelected}
          />
        </div>
      </div>

      <DataTable
        columns={getColums()}
        data={getDataColums()}
        className={style.table}
        pagination={20}
      />
      {_taxonomyToDelete && (
        <TurbineManagementDelete
          taxonomySelected={taxonomySelected}
          // @ts-ignore
          turbine={getTaxonomy(_taxonomyToDelete)}
          // @ts-ignore
          windFarm={getTaxonomy(_taxonomyToDelete)}
          // @ts-ignore
          asset={getTaxonomy(_taxonomyToDelete)}
          // @ts-ignore
          bearing={getTaxonomy(_taxonomyToDelete)}
          onClose={onTurbneManagerDeleteClose}
        />
      )}

      {_openModal && (
        <TurbineManagementFormulary
          turbines={_turbine}
          taxonomy={_taxonomyToFormulary}
          onClose={onTurbneManagerFormularyClose}
        />
      )}
      {_openModalTurbine && (
        <TurbineManagementFormularyTurbine
          assets={_turbine}
          turbineOptions={_turbineOptions}
          turbines={_turbine}
          windfarms={_windFarm}
          // @ts-ignore
          taxonomy={_taxonomyToFormulary}
          onClose={onTurbneManagerFormularyClose}
        />
      )}
      {_openModalAssets && (
        <TurbineManagementFormularyAssets
          assets={_assetToFormulary ? _assetToFormulary : undefined}
          turbines={_turbine}
          windfarms={_windFarm}
          // @ts-ignore
          taxonomy={_taxonomyToFormulary}
          onClose={onTurbneManagerFormularyClose}
          turbineSelected={turbineSelected}
        />
      )}

      {_openModalBearings && (
        <TurbineManagementFormularyBearings
          // @ts-ignore
          taxonomy={_taxonomyToFormulary}
          windfarms={_windFarm}
          turbines={_turbine}
          assets={_assets}
          onClose={onTurbneManagerFormularyClose}
        />
      )}
    </div>
  );
};
